import { custom } from '@carboledger/ui';
import { referenceIdNumberRule, positiveNumberRule } from '@/lib/validation';
import { getTranslation } from '@/lib/utils/i18n';

// Format-only rules for the "Create new outgoing shipment" fieldset; each field's own `required` prop makes it mandatory.
export const fulfillOrderValidation = {
  idNumber: referenceIdNumberRule,
};

/**
 * @param remaining  { toShip, toAllocate } in the currently selected unit, or undefined
 *                   when the order carries no amount for that unit
 */
export const buildFulfillQuantityRules = (remaining) => [
  ...positiveNumberRule,
  custom((value) => !value || Number(value) > 0, getTranslation('ORDERS_FULFILL_QUANTITY_MIN')),
  custom(
    (value) => !value || remaining?.toAllocate == null || Number(value) <= remaining.toAllocate,
    getTranslation('ORDERS_FULFILL_QUANTITY_EXCEEDS_ALLOCATE'),
  ),
  custom(
    (value) => !value || remaining?.toShip == null || Number(value) <= remaining.toShip,
    getTranslation('ORDERS_FULFILL_QUANTITY_EXCEEDS_SHIP'),
  ),
];
